import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import * as actions from '@actions';

export type TimingEvent =
  | 'REGISTRATION_START'
  | 'REGISTRATION_END'
  | 'NAME_AND_EMAIL_START'
  | 'NAME_AND_EMAIL_END'
  | 'EMAIL_VERIFICATION_START'
  | 'EMAIL_VERIFICATION_END'
  | 'MOBILE_VERIFICATION_START'
  | 'MOBILE_VERIFICATION_END'
  | 'IDENTITY_INFO_START'
  | 'IDENTITY_INFO_END'
  | 'ADDRESS_INFO_START'
  | 'ADDRESS_INFO_END'
  | 'GP_INFO_START'
  | 'GP_INFO_END';

export function useTimingEvents(onMount: TimingEvent, onUnmount?: TimingEvent) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.usersTimingEvent(onMount));

    return () => {
      if (onUnmount) dispatch(actions.usersTimingEvent(onUnmount)).catch(console.error);
    };
  }, [dispatch, onMount, onUnmount]);
}

export default useTimingEvents;
